/**
 * util functions to maintain middle state (null) for Boolean and Number
 */
const isNumeric = (val?: string | number | null) =>
  Boolean(!isNaN(Number(val)) && isFinite(Number(val)) && val !== null && val !== undefined && val !== '');

const booleanToLabel = (val: boolean | null | undefined, trueLabel: string, falseLabel: string): string | undefined => {
  if (val === undefined || val === null) return undefined;
  return val ? trueLabel : falseLabel;
};

const typeCheckUtils = {
  Boolean: (val?: boolean | null) => (val === null || val === undefined ? null : Boolean(val)),
  Number: (val?: string | number | null) => (isNumeric(val) ? Number(val) : null),
  booleanToLabel,
  booleanToYesNo: (val?: boolean | null) => booleanToLabel(val, 'Yes', 'No'),
  isNumeric,
};

export default typeCheckUtils;
